import { createRequestTypes, generateRequestActions } from 'utils/actionHelpers'

export const HOME_PAGE_CONTACT_SUBMIT_REQ = createRequestTypes(
  'HOME_PAGE_CONTACT_SUBMIT',
)
export const homePageContactSubmit = generateRequestActions(
  HOME_PAGE_CONTACT_SUBMIT_REQ,
)
